import { ReactNode, FC } from 'react'
import {
  FormItemTitle,
  FormItemSubtitle,
  FlexDiv,
} from 'src/components/application/formComponents/styles'
import {
  FormItemContainer,
} from 'src/components/application/defaultComponents'
import { LeftBar } from 'src/components/basic/LeftBar'
import StepBullet from 'src/components/basic/StepBullet'

interface Props {
  children: ReactNode;
  step: number;
  title: string;
  subtitle?: string;
  leftBar?: boolean;
  isValid?: boolean;
  maxWidth?: string;
}

const FormItemComponent: FC<Props> = ({ children, step, title, subtitle, leftBar, isValid, maxWidth }) => (
  <FormItemContainer maxWidth={maxWidth}>
    <StepBullet id={`step${step}`} isComplete={isValid === true}>{step}</StepBullet>
    <FlexDiv gap="24px" dir="column">
      <FlexDiv dir="column">
        <FormItemTitle>{title}</FormItemTitle>
        {!!subtitle ? <FormItemSubtitle>{subtitle}</FormItemSubtitle> : null}
      </FlexDiv>
      <FlexDiv gap="24px">
        {leftBar === true ? (
          <LeftBar/>
        ) : null}
        <FlexDiv dir="column" gap="24px">
          {children}
        </FlexDiv>
      </FlexDiv>
    </FlexDiv>
  </FormItemContainer>
)

export default FormItemComponent